import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchCases = (params = {}) => api.get("/cases", { params }).then((r) => r.data);
export const fetchCase = (caseId) => api.get(`/cases/${caseId}`).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const sendChat = (payload) => api.post("/chat", payload).then((r) => r.data);
export const explainCase = (caseId, perspective) =>
  api.post(`/cases/${caseId}/explain`, { perspective }).then((r) => r.data);

export const refreshSource = () => api.post("/refresh").then((r) => r.data);
export const listSessions = () => api.get("/chat/sessions").then((r) => r.data);
export const getSession = (id) => api.get(`/chat/sessions/${id}`).then((r) => r.data);
export const deleteSession = (id) => api.delete(`/chat/sessions/${id}`).then((r) => r.data);

export const fetchMyPins = () => api.get("/me/pins").then((r) => r.data);
export const fetchMySubscription = () => api.get("/me/subscription").then((r) => r.data);
export const cancelMySubscription = () => api.delete("/me/subscription").then((r) => r.data);
export const claimAnonPins = (file_ids) =>
  api.post("/me/pins/claim", { file_ids }).then((r) => r.data);
